import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {DefaultDataServiceConfig, Logger} from '@ngrx/data';
import {AbstractDataServiceV2} from 'src/app/modules/core/service/v2/dataservice/abstractDataServiceV2';
import {CustomizeHttpUrlGenerator} from 'src/app/store/core/url/customizeHttpUrlGenerator';
import {LovValue} from '../../../api/model/LovValue.model';
import {LovValueConverter} from '../../../api/converter/LovValue.converter';


@Injectable({providedIn: 'root'})
export class LovValueDataService extends AbstractDataServiceV2<LovValue, LovValueConverter> {
    constructor(http: HttpClient, httpUrlGenerator: CustomizeHttpUrlGenerator,
                logger: Logger, config: DefaultDataServiceConfig,
                converter: LovValueConverter) {
        super('LovValue', http, httpUrlGenerator, logger, config, converter);
    }
}
